import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type EmployerICHRAConfig } from '../brokers/types'

export type GetBrokersEmployerICHRAConfigsParams = {
  employerId: string
}

export function useGetBrokersEmployerICHRAConfigsQueryKey ({
  employerId,
}: GetBrokersEmployerICHRAConfigsParams) {
  return ['brokers', 'employer', employerId, 'ichra_configs']
}

export function useGetBrokersEmployerICHRAConfigs ({
  employerId,
}: GetBrokersEmployerICHRAConfigsParams) {
  return useQuery<EmployerICHRAConfig[], GrapeAPIErrorType>({
    queryKey: useGetBrokersEmployerICHRAConfigsQueryKey({ employerId }),
    queryFn: async () => {
      const response = await fetchWithHeaders(`/api/web/brokers/employers/${employerId}/ichra_configs`)

      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }

      return response.json()
    },
    enabled: !!employerId,
  })
}
